import { PermissionsType } from '@/common/types/permissions';
import { FC, PropsWithChildren } from 'react';

type AuthCheckProps = PropsWithChildren<{
  permissions?: PermissionsType;
}>;

const AuthCheck: FC<AuthCheckProps> = ({ children }) => {
  return children;
};

export default AuthCheck;
